import {
  addLoading,
  changePassword,
  forceLogout,
  hideAlert,
  hideConfirm,
  login,
  logout,
  removeLoading,
  showConfirm,
  showError,
  showSuccess,
  toggleMenu,
  updateAccountInfo,
  createLocationAsync,
  updateDbAsync,
  createPrivateDbAsync,
  disableApiKeyAsync,
  createApiKeyAsync,
} from '@redux/actions';
import { updateUserIdAsync } from '@redux/actions/apiActions/userIdDetailAction';
import { createSlice } from '@reduxjs/toolkit';

const initialState: AppState = {
  openMenu: true,
  loadingCount: 0,
  alert: { show: false },
  dialogConfirm: { show: false },
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(toggleMenu, (state) => {
        state.openMenu = !state.openMenu;
      })
      .addCase(addLoading, (state) => {
        state.loadingCount++;
      })
      .addCase(removeLoading, (state) => {
        state.loadingCount--;
      })
      .addCase(showError, (state, { payload }) => {
        state.alert = {
          show: true,
          type: 'error',
          ...payload,
        };
      })
      .addCase(showSuccess, (state, { payload }) => {
        state.alert = {
          show: true,
          type: 'success',
          ...payload,
        };
      })
      .addCase(hideAlert, (state) => {
        state.alert.show = false;
      })
      .addCase(showConfirm, (state, { payload }) => {
        state.dialogConfirm = {
          show: true,
          ...payload,
        };
      })
      .addCase(hideConfirm, (state) => {
        state.dialogConfirm.show = false;
      })
      .addCase(forceLogout, (state) => {
        state.alert = {
          show: true,
          type: 'warning',
          message: 'MSW00003',
        };
      })
      .addCase(login.fulfilled, (state, { payload }) => {
        if (payload.user.forceChangePassword) {
          state.alert = {
            show: true,
            type: 'warning',
            message: 'MSW00004',
          };
        } else if (payload.user.isNew) {
          state.alert = {
            show: true,
            type: 'warning',
            message: 'MSW00005',
          };
        }
      })
      .addCase(logout.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00005',
        };
      })
      .addCase(changePassword.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(createApiKeyAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00004',
        };
      })
      .addCase(disableApiKeyAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(updateAccountInfo.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(createLocationAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00004',
        };
      })
      .addCase(updateDbAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(createPrivateDbAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00004',
        };
      })
      .addCase(updateUserIdAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      });
  },
});

export default appSlice.reducer;
